<section class="hero-area-bg" id="hero-area">
    <div class="container">
        <div class="row align-items-center row-flex">
            <div class="col-lg-7 col-md-12 col-sm-12 col-xs-12 left-bg">
                <div class="neet-contents">
                    <h1 class="head-title">Your Code to <span class="head-span">Success</span><br> in JEE</h1>
                    <p>Get access to unlimited live classes with India’s Top Faculties</p>
                    <div class="number-field m-auto" [formGroup]='mobileNumberForm'>
                        <span class="code">+ 91</span>
                        <input type="tel" maxlength="10" class="numbertest-input" (onchange)="onInputChange()"
                            (keyup)="onInputChange()" placeholder="MOBILE NUMBER" formControlName='phone'>
                        <button type="button" (click)="signup('jee_lc_1', {number: mobileNumberForm.value.phone, dialCode: '+91'})" [disabled]="!mobileNumberValid"
                            class="start-btn"><b>START LEARNING </b></button>
                    </div>
                    
                    <div class="d-flex justify-content-center IL_sc-click font-weight-bold">
                        <span class="assessment_mt-10" *ngIf="tenant != 'srichaitanya'">Sri Chaitanya students <span (click)="userService.gotoSC($event)" class="IL_sc-click-btn">click here</span>  to login</span>
                    </div>
                </div>

            </div>

            <div class="col-lg-5 col-md-12 col-sm-12 col-xs-12 right-bg">
                <div class="intro-img">
                    <img src="assets/img/neet-landing/neet-introgirl.png" class="img-fluid deskimg-show" alt="">
                    <img src="assets/img/neet-landing/1.png" class="img-fluid mobile-show" alt="">
                </div>

            </div>

        </div>

    </div>


</section>
    <!-- key features area  -->
    <section class="keyfeature-area">
        <div class="container">
            <div class="feature-head">
                <h1>Key <span class="featues">Features</span> of the Course</h1>
            </div>
            <div class="row">
                <div class="col-lg-4 col-md-6 col-xs-12">
                    <div class="feature-box">
                        <div class="feature-icon">
                            <figure>
                                <img src="assets/img/f1.png" alt="">
                            </figure>
                        </div>
                        <h4>Interactive Live classes</h4>
                        <p>Learn live from experienced faculty and improve conceptual clarity and retention of concepts.</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-xs-12">
                    <div class="feature-box">
                        <div class="feature-icon">
                            <figure>
                                <img src="assets/img/f2.png" alt="">
                            </figure>
                        </div>
                        <h4>Recordings for classes</h4>
                        <p>Unlimited access to all recordings to rewatch and revise your classes anytime anywhere.</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-xs-12">
                    <div class="feature-box">
                        <div class="feature-icon">
                            <figure>
                                <img src="assets/img/f3.png" alt="">
                            </figure>
                        </div>
                        <h4>Instant doubt clarification</h4>
                        <p>Get doubts solved immediately during classes through live chat.</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-xs-12">
                    <div class="feature-box">
                        <div class="feature-icon">
                            <figure>
                                <img src="assets/img/f4.png" alt="">
                            </figure>
                        </div>
                        <h4>Live Quizzes and Polls</h4>
                        <p>Take live quizzes and polls during the class to test yourself on concepts learned during class.</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-xs-12">
                    <div class="feature-box">
                        <div class="feature-icon">
                            <figure>
                                <img src="assets/img/f5.png" alt="">
                            </figure>
                        </div>
                        <h4>Notes</h4>
                        <p>Access to class notes after every class for you to revisit and revise the class anytime.</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-xs-12">
                    <div class="feature-box">
                        <div class="feature-icon">
                            <figure>
                                <img src="assets/img/f6.png" alt="">
                            </figure>
                        </div>
                        <h4>Assignments</h4>
                        <p>Daily practice problems to apply your learning after every class and get instant performance reports.</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-xs-12">
                    <div class="feature-box">
                        <div class="feature-icon">
                            <figure>
                                <img src="assets/img/f7.png" alt="">
                            </figure>
                        </div>
                        <h4>Progress & Performance reports</h4>
                        <p>Track progress and performance through detailed reports to identify areas of strengths and improvement.</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-xs-12">
                    <div class="feature-box">
                        <div class="feature-icon">
                            <figure>
                                <img src="assets/img/f8.png" alt="">
                            </figure>
                        </div>
                        <h4>Regular Tests</h4>
                        <p>Chapter-wise tests and detailed performance reports including topic-wise areas of strength and improvement.</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-xs-12">
                    <div class="feature-box">
                        <div class="feature-icon">
                            <figure>
                                <img src="assets/img/f9.png" alt="">
                            </figure>
                        </div>
                        <h4>Syllabus Coverage</h4>
                        <p>100% in line with your exam syllabus.</p>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- course highlights -->
    <section class="course-highlights-sec">
        <div class="container">
             <div class="course-head">
                <h1>Course Highlights - <span class="grade">Grade 11 JEE</span></h1>
            </div>
            <div class="row">
                <div class="col-lg-4 col-md-6 col-xs-12">
                    <div class="course-box">
                        <div class="course-icon">
                            <figure>
                                <img src="assets/img/c1.png" alt="">
                            </figure>
                        </div>
                        <div class="course-content">
                            <h4>Syllabus</h4>
                            <p>Grade 11 JEE</p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-xs-12">
                    <div class="course-box">
                        <div class="course-icon">
                            <figure>
                                <img src="assets/img/c2.png" alt="">
                            </figure>
                        </div>
                        <div class="course-content">
                            <h4>Subjects</h4>
                            <p>Physics, Chemistry, Maths</p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-xs-12">
                    <div class="course-box">
                        <div class="course-icon">
                            <figure>
                                <img src="assets/img/c3.png" alt="">
                            </figure>
                        </div>
                        <div class="course-content">
                            <h4>Duration</h4>
                            <p>24 weeks | 350+ hour</p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-xs-12">
                    <div class="course-box">
                        <div class="course-icon">
                            <figure>
                                <img src="assets/img/c4.png" alt="">
                            </figure>
                        </div>
                        <div class="course-content">
                            <h4>Batch start</h4>
                            <p>9<sup>th</sup> September 2021</p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-xs-12">
                    <div class="course-box">
                        <div class="course-icon">
                            <figure>
                                <img src="assets/img/c4.png" alt="">
                            </figure>
                        </div>
                        <div class="course-content">
                            <h4>Batch end</h4>
                            <p>2<sup>nd</sup> week of March 2022</p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-xs-12">
                    <div class="course-box">
                        <div class="course-icon">
                            <figure>
                                <img src="assets/img/c6.png" alt="">
                            </figure>
                        </div>
                        <div class="course-content">
                            <h4>Timetable</h4>
                            <p>5-6 days a week, evening classes.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row justify-content-center assessment_mt-25">
            <div class="number-field" [formGroup]='mobileNumberForm'>
                <span class="code">+ 91</span>
                <input type="tel" maxlength="10" class="numbertest-input" (onchange)="onInputChange()"
                    (keyup)="onInputChange()" placeholder="MOBILE NUMBER" formControlName='phone'>
                <button type="button" (click)="signup('jee_lc_1', {number: mobileNumberForm.value.phone, dialCode: '+91'})" [disabled]="!mobileNumberValid" class="start-btn"><b>START
                        LEARNING</b></button>
            </div>
        </div>
          
        <div class="d-flex justify-content-center IL_sc-click font-weight-bold  assessment_mb-25">
            <span class="assessment_mt-10" *ngIf="tenant != 'srichaitanya'">Sri Chaitanya students <span (click)="userService.gotoSC($event)" class="IL_sc-click-btn">click here</span>  to login</span>
        </div>
    </section>

<!-- Live Class starts -->
<section class="liveclass-area">
    <div class="container">
        <div class="row">
            <div class="col-lg-6 col-md-12 col-xs-12">
                <div class="liveclass-wrapper">
                    <div class="liveclass-head">
                        <h1>Experience The<span class="live-span"><br> Live Class</span></h1>
                        <p>Meet your faculty and get the real experience </p>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-12 col-xs-12">
                <div>
                    <iframe width="100%" height="325" src="https://www.youtube.com/embed/klMcFP5fMaY" frameborder="0"
                        allow="autoplay; encrypted-media" allowfullscreen=""></iframe>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- Our faculty -->
<section class="faculty-area">
    <div class="container">
        <div class="ourfaculty-head">
            <h1>Our <span class="head-span">Faculties</span> </h1>
        </div>
        <div class="row">
                <div class="col-lg-4 col-xs-12">
                    <div class="inner-box">
                        <div class="faculty-img">
                            <a href="">
                                <figure>
                                    <img src="assets/img/basheerjee.png" alt="basheer_shaik" />
                                </figure>
                            </a>
                        </div>
                        <div class="inner-content">
                            <h4>Basheer Shaik</h4>
                            <h6>Sr. Mathematics Faculty</h6>
                            <p>Basheer Shaik is a double gold medallist, B.Ed with master’s degree in Mathematics and has 15+ years of teaching
                                experience. He has taught top batches and produced many single and double digit ranks such as AIR 5, AIR 18, AIR 118
                                in JEE Mains and JEE Advanced</p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-xs-12">
                    <div class="inner-box">
                        <div class="faculty-img">
                            <a href="">
                                <figure>
                                    <img src="assets/img/neet-landing/Aman.png" alt="Aman Kumar" />
                                </figure>
                            </a>
                        </div>
                        <div class="inner-content">
                            <h4>Aman Varma</h4>
                            <h6>Sr. Chemistry Faculty</h6>
                            <p>Aman Kumar Varma, B.E. in Chemical Engineering from Sir Visvesvaraya Institute of
                                Technology, Nashik, has 8+ years of
                                experience in teaching Chemistry for JEE.</p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-xs-12">
                    <div class="inner-box">
                        <div class="faculty-img">
                            <a href="">
                                <figure>
                                    <img src="assets/img/supreetjee.png" alt="supreet" />
                                </figure>
                            </a>
                        </div>
                        <div class="inner-content">
                            <h4>Supreet Singh</h4>
                            <h6>Sr. Physics Faculty</h6>
                            <p>Supreet Singh, B.Tech in Electronics & Communication and M.Tech in Electronics, has 9 + years of experience in
                                teaching Physics for both JEE students. He has mentored more than 5000 students in both online and offline
                                classes and produced multiple all India ranks.
                            </p>
                        </div>
                    </div>
                </div>
                <!-- <div class="faculty-flex">
                    <div class="item">
                        
                    </div>
                    <div class="item">
                        
                    </div>
                    <div class="item">
                        
                    </div>
                </div> -->
        </div>
    </div>
</section>
<!-- footer area -->
<!-- <footer class="footer-area">
        <div class="container">
            <div class="row">
                <div class="col-lg-6 col-md-12 col-xs-12">
                    <div class="copy-left">
                        <p>Copyright © 2021, All Rights Reserved </p>
                    </div>
                </div>
                <div class="col-lg-6 col-md-12 col-xs-12">
                    <div class="social">
                        <ul class="socialmedia">
                            <li><a href=""><i class="fa fa-facebook" aria-hidden="true"></i></a></li>
                            <li><a href=""><i class="fa fa-linkedin" aria-hidden="true"></i></a></li>
                            <li><a href=""><i class="fa fa-twitter" aria-hidden="true"></i></a></li>
                            <li><a href=""><i class="fa fa-instagram" aria-hidden="true"></i></a></li>
                            <li><a href=""><i class="fa fa-youtube-play" aria-hidden="true"></i></a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </footer> -->
    <app-footer></app-footer>
<script src="https://cdn.jsdelivr.net/npm/popper.js@1.16.1/dist/umd/popper.min.js"
    integrity="sha384-9/reFTGAW83EW2RDu2S0VKaIzap3H66lZH81PoYlFhbGU+6BZp6G7niu735Sk7lN"
    crossorigin="anonymous"></script>
